import { render, staticRenderFns } from "./kfmv-wizard.vue?vue&type=template&id=4cdde25e"
import script from "./kfmv-wizard.vue?vue&type=script&lang=ts"
export * from "./kfmv-wizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports